// @flow
import { compose, withProps } from 'recompose'
import { reduxForm, SubmissionError } from 'redux-form'
import { connect } from 'react-redux'
import withTranslations from '../../../core/withTranslations'
import withHandleCancel from '../withHandleCancel'
import withUserCharityId from './withUserCharityId'
import ContactForm from '../../../ui/forms/contact-form'
import { closeContactFormModal, createContact, updateContact } from './actions'
import {
  isEditingContactFormMode,
  getModalContactId,
  getContact
} from './selectors'
import { CONTACT_FORM_MODAL } from './constants'
import {
  validateRequired,
  validateEmail,
  validatePhoneNumber
} from '../../validations/validations'

const translations = withTranslations({
  nameLabel: 'forms.field.name.label',
  phoneLabel: 'forms.field.phone.label',
  faxLabel: 'forms.field.fax.label',
  emailLabel: 'forms.field.email.label',
  cancelText: 'common:cancel',
  saveText: 'common:save',
  errorNameAndOneContactDataText: 'forms.validation.errorNameAndOneContactData'
})

const mapStateToProps = state => {
  const contactId = getModalContactId(CONTACT_FORM_MODAL, state)
  const contact = getContact(contactId, state)
  return {
    isEditingMode: Boolean(isEditingContactFormMode(state)),
    contact
  }
}
const mapDispatchToProps = {
  createContact,
  updateContact,
  onCloseContactFormModal: closeContactFormModal
}
const withActionsAndSelector = connect(mapStateToProps, mapDispatchToProps)

const initialValues = contact => ({
  name: contact.name,
  phone: contact.phone,
  fax: contact.fax,
  email: contact.email
})

const withFormProps = withProps(props => {
  const {
    isEditingMode,
    updateContact,
    createContact,
    onCloseContactFormModal
  } = props
  return {
    theme: 'light-theme',
    onSave: isEditingMode ? updateContact : createContact,
    onCancel: onCloseContactFormModal,
    initialValues: isEditingMode ? initialValues(props.contact) : {}
  }
})

const withReduxForm = reduxForm({
  form: 'addContact',
  validate: values => ({
    name: validateRequired(values.name),
    phone: values.phone && validatePhoneNumber(values.phone),
    fax: values.fax && validatePhoneNumber(values.fax),
    email: values.email && validateEmail(values.email)
  }),
  onSubmit: (values, dispatch, props) => {
    const {
      errorOneContactDataText,
      isEditingMode,
      contact,
      charityId,
      onSave,
      onCloseContactFormModal
    } = props
    const { phone, fax, email } = values
    if (!phone && !fax && !email)
      throw new SubmissionError(errorOneContactDataText)
    const id = isEditingMode ? contact.id : charityId
    return onSave(id, values).then(onCloseContactFormModal())
  }
})

export const ContactFormEnhancer = compose(
  translations,
  withUserCharityId,
  withActionsAndSelector,
  withFormProps,
  withReduxForm,
  withHandleCancel
)

export default ContactFormEnhancer(ContactForm)



// WEBPACK FOOTER //
// ./src/services/mycharity/charity/ContactForm.js